export const CHART_AXIS_TICK = { fontSize: 11, fill: "hsl(var(--muted-foreground))" };

export const CHART_GRID_PROPS = {
  strokeDasharray: "3 3",
  stroke: "hsl(var(--border))",
  vertical: false,
};

export const CHART_TOOLTIP_PROPS = {
  contentStyle: {
    backgroundColor: "hsl(var(--card))",
    border: "1px solid hsl(var(--ring))",
    borderRadius: "calc(var(--radius) - 2px)",
    fontSize: "12px",
    color: "hsl(var(--foreground))",
    boxShadow: "none",
  },
  itemStyle: { color: "hsl(var(--foreground))" },
  labelStyle: { color: "hsl(var(--muted-foreground))", marginBottom: "4px" },
  cursor: { fill: "hsl(var(--accent) / 0.15)" },
};
